import "@scss/modules/internal.scss";

import "@splidejs/splide/dist/css/splide.min.css";
import "tippy.js/dist/tippy.css";
import "flatpickr/dist/flatpickr.min.css";
import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";

import TKModuleFactory from "@tk/utilities/tk.module.factory";
import TKManager from "@tk/basiscs/tk.manager";
import TKStyleguideFormHelper from "@tk/utilities/tk.styleguide.form.helper";
import TKButtonDropdown from "@tk/controls/tk.button.dropdown";
import TKCodeblock from "@tk/controls/tk.codeblock";
import TKFormDatepicker from "@tk/controls/tk.form.datepicker";
import TKFormElement from "@tk/controls/tk.form.element";
import TKFormRangeslider from "@tk/controls/tk.form.rangeslider";
import TKFormTimepicker from "@tk/controls/tk.form.timepicker";
import TKFormValidator from "@tk/controls/tk.form.validator";
import TKTabsAccordion from "@tk/controls/tk.tabs.accordion";
import TKTabsTab from "@tk/controls/tk.tabs.tab";
import TKSearch from "@tk/controls/tk.search";
import TKTable from "@tk/components/tk.table";
import TKHeader from "@tk/components/tk.header";
import TKFlag from "@tk/components/tk.flag";
import TKTooltip from "@tk/components/tk.tooltip";
import TKCarousel from "@tk/components/tk.carousel";
import TKViewport from "@tk/basiscs/tk.viewport";
import TKNavigationSidebar from "@tk/components/tk.navigation.sidebar";
import TKAssetGallery from "@tk/components/tk.asset.gallery";
import TKProductVariants from "@tk/components/tk.product.variants";
import TKBasketButton from "@tk/components/tk.basket.button";
import TKDialog from "@tk/components/tk.dialog";
import TKMinibasket from "@tk/components/tk.minibasket";
import TKContextMenu from "@tk/components/tk.context.menu";
import TKFilter from "@tk/components/tk.filter";
import TKFilterChip from "@tk/components/tk.filter.chip";
import TKFilterResult from "@tk/components/tk.filter.result";
import TKFilterDropdown from "@tk/components/tk.filter.dropdown";
import TKFilterGroupWrapper from "@tk/components/tk.filter.group.wrapper";
import TKFilterGroup from "@tk/components/tk.filter.group";
import TKFilterSearch from "@tk/components/tk.filter.search";
import TKFilterSelectReset from "@tk/components/tk.filter.select.reset";
import TKFilterDrilldownButton from "@tk/components/tk.filter.drilldown.button";
import TKStaticContent from "@tk/controls/tk.static.content";
import TKFileUploadArea from "@tk/controls/tk.file.upload.area";
import TKShowMore from "@tk/components/tk.show.more";

export default class Internal extends TKModuleFactory {
    constructor() {
        super([
            { name: "tk-manager", constructor: TKManager },
            { name: "tk-viewport", constructor: TKViewport },
            { name: "tk-codeblock", constructor: TKCodeblock },
            { name: "tk-tabs-accordion", constructor: TKTabsAccordion },
            { name: "tk-tabs-tab", constructor: TKTabsTab },
            { name: "tk-button-dropdown", constructor: TKButtonDropdown },
            { name: "tk-tabs-accordion", constructor: TKTabsAccordion },
            { name: "tk-form-datepicker", constructor: TKFormDatepicker },
            { name: "tk-form-element", constructor: TKFormElement },
            { name: "tk-form-timepicker", constructor: TKFormTimepicker },
            { name: "tk-form-range-slider", constructor: TKFormRangeslider },
            { name: "tk-form-validator", constructor: TKFormValidator },
            { name: "tk-table", constructor: TKTable },
            { name: "tk-search", constructor: TKSearch },
            { name: "tk-header", constructor: TKHeader },
            { name: "tk-flag", constructor: TKFlag },
            { name: "tk-tooltip", constructor: TKTooltip },
            { name: "tk-carousel", constructor: TKCarousel },
            { name: "tk-nav-sidebar", constructor: TKNavigationSidebar },
            { name: "tk-asset-gallery", constructor: TKAssetGallery },
            { name: "tk-product-variants", constructor: TKProductVariants },
            { name: "tk-basket-button", constructor: TKBasketButton },
            { name: "tk-dialog", constructor: TKDialog },
            { name: "tk-minibasket", constructor: TKMinibasket },
            { name: "tk-context-menu", constructor: TKContextMenu },
            { name: "tk-filter", constructor: TKFilter },
            { name: "tk-filter-chip", constructor: TKFilterChip },
            { name: "tk-filter-result", constructor: TKFilterResult },
            { name: "tk-filter-dropdown", constructor: TKFilterDropdown },
            {
                name: "tk-filter-group-wrapper",
                constructor: TKFilterGroupWrapper,
            },
            { name: "tk-filter-group", constructor: TKFilterGroup },
            { name: "tk-filter-search", constructor: TKFilterSearch },
            {
                name: "tk-filter-select-reset",
                constructor: TKFilterSelectReset,
            },
            {
                name: "tk-filter-drilldown-button",
                constructor: TKFilterDrilldownButton,
            },
            { name: "tk-static-content", constructor: TKStaticContent },
            { name: "tk-file-upload-area", constructor: TKFileUploadArea },
            {
                name: "tk-stylguide-form-helper",
                constructor: TKStyleguideFormHelper,
            },
            { name: "tk-show-more", constructor: TKShowMore },
        ]);
    }
}

// eslint-disable-next-line no-new
new Internal();
